import { loremIpsum } from 'lorem-ipsum';
import * as yup from 'yup';

export const paragraphInitialValues = {
    content: loremIpsum(),
};

export const paragraphForm = [
    {
        id: '1',
        label: 'content',
        name: 'content',
        type: 'text',
        multiline: true,
        rows: 2,
        rowsMax: 4,
        component: 'FormikTextField',
        style: { minWidth: '400px' },
    },
];

export const paragraphValidation = {
    content: yup
        .string()
        .matches(/^[a-zA-Z0-9!£$%,. ]*$/, 'Alphanumeric characters only')
        .required(),
};
